import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./NavItem.module.css";
import DropdownMenu from "../DropdownMenu/DropdownMenu";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

export default function NavItem({
  label,
  options,
  border,
  onClick,
  onLabelClick,
  path,
}) {
  const [isVisible, setIsVisible] = useState(false);

  // const toggleVisibility = (e) => {
  //   setIsVisibile(!isVisible);
  // };

  const toggleVisibility = (event) => {
    event.stopPropagation();
    setIsVisible((prev) => !prev);
  };

  const noVisibility = () => {
    setIsVisible(false);
  };

  return (
    <>
      <div className={styles.container}>
        {options.length > 0 ? (
          <div className={styles.dropdown}>
            <button
              className={
                border === true ? styles.buttonBorder : styles.buttonNoBorder
              }
            >
              {label} <FontAwesomeIcon icon={faChevronDown} />
            </button>
            <div className={styles.dropdownMenu}>
              <DropdownMenu
                options={options}
                onOptionClick={(option) => {
                  onClick(option.path);
                  setIsVisible(false);
                }}
              />
            </div>
          </div>
        ) : (
          <button
            className={
              border === true ? styles.buttonBorder : styles.buttonNoBorder
            }
            onClick={(e) => {
              e.preventDefault(); // Prevent default button behavior
              if (onClick && path) {
                onClick(path); // Pass only the path, not the event object
              }
            }}
          >
            {label}
          </button>
        )}
      </div>
    </>
  );
}

// return (
//   <>
//     <div className={styles.container}>
//       {options.length > 0 ? (
//         <div className={styles.dropdown}>
//           <button
//             className={
//               border === true ? styles.buttonBorder : styles.buttonNoBorder
//             }
//           >
//             {label} <FontAwesomeIcon icon={faChevronDown} />
//           </button>
//           {/* {isVisible && ( */}
//           <div className={styles.dropdownMenu}>
//             <DropdownMenu
//               options={options}
//               // parentLabel={() => onLabelClick(label)}

//               parentLabel={label}
//               onLabelClick={onLabelClick}
//             />
//           </div>
//           {/* )} */}
//         </div>
//       ) : (
//         <button
//           className={
//             border === true ? styles.buttonBorder : styles.buttonNoBorder
//           }
//           onClick={onClick}
//         >
//           {label}
//         </button>
//       )}
//     </div>
//   </>
// );

NavItem.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      path: PropTypes.string,
    })
  ),
  border: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onLabelClick: PropTypes.func,
  path: PropTypes.string,
};
